export const DEFAULT_FORM_NAME = 'VALIDATE_PASSWORD';
export const DYNAMIC_VALIDATE_PASSWORD = 'dynamic-validate-password';
